import React from "react";
import withIntl from "../../utils/withIntl";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import EditPriceTextField from "../EditArticle/EditPriceTextField";
import EditTextField from "../EditArticle/EditTextField";
import { InputAdornment, Typography } from "@material-ui/core";
import EditSwitch from "../EditArticle/EditSwitch";
import { paymentMethodNamesGeneral, paymentMethodNamesPaynl } from "./PaymentMethods";
import EditPercentageTextField from "../EditArticle/EditPercentageTextField";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import List from "@material-ui/core/List";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import AuthorizationWrapper from "../AuthorizationWrapper";
import cloudStore from "../../store/CloudStore";

const getAllPaymentMethods = (merchant, paymentMethods) => {
  let paymentMethodNames = { ...paymentMethodNamesGeneral };
  if (merchant.paynl_merchants.length>0) {
    paymentMethodNames = { ...paymentMethodNames, ...paymentMethodNamesPaynl };
  }
  if (merchant.opp_merchant !== null) {
    // paymentMethodNames = { ...paymentMethodNames, ...paymentMethodNamesOpp };
  }
  Object.keys(paymentMethodNames).forEach((paymentMethodNameFromAllPaymentMethods) => {
    let index = paymentMethods.findIndex((paymentMethodEntry) => {
      let paymentMethodName = Object.keys(paymentMethodEntry)[0];
      return paymentMethodName === paymentMethodNameFromAllPaymentMethods;
    });

    if (index === -1) {
      paymentMethods.push({
        [paymentMethodNameFromAllPaymentMethods]: {
          ...inhousePaymentMethod,
          name: paymentMethodNames[paymentMethodNameFromAllPaymentMethods],
        },
      });
    } else {
      let paymentMethod = paymentMethods[index][paymentMethodNameFromAllPaymentMethods];
      if (paymentMethod.extra_costs == null) {
        paymentMethod.extra_costs = 0;
      }
      if (paymentMethod.extra_percentage == null) {
        paymentMethod.extra_percentage = 0;
      }
      if (paymentMethod.description == null) {
        paymentMethod.description = null;
      }
      paymentMethod.name = paymentMethodNames[paymentMethodNameFromAllPaymentMethods];
    }
  });
  return paymentMethods;
};

const inhousePaymentMethod = { extra_costs: 0, extra_percentage: 0, description: null, active: 0 };

function PaymentMethodInhouse(props) {
  const [paymentMethods, setPaymentMethods] = React.useState(
    getAllPaymentMethods(cloudStore.merchant, props.paymentMethods)
  );

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    let destinationIndex = result.destination.index;
    let sourceIndex = result.source.index;
    if (destinationIndex === sourceIndex) {
      return;
    }

    paymentMethods.splice(destinationIndex, 0, paymentMethods.splice(sourceIndex, 1)[0]);
    props.onSave(paymentMethods).then(() => {
      setPaymentMethods(paymentMethods);
    });
  };

  return (
    <>
      <Grid style={{ marginTop: 12 }} container spacing={1}>
        <Grid item xs={3} style={{ fontWeight: 700 }}>
          {props.intl.formatMessage({ id: "payment_methods" })}
        </Grid>
        <Grid item xs={3}>
          {props.intl.formatMessage({ id: "custom_name" })}
        </Grid>
        <Grid item xs={2}>
          {props.intl.formatMessage({ id: "costs" })}
        </Grid>
        <Grid item xs={2}>
          {props.intl.formatMessage({ id: "costs_percentage" })}
        </Grid>
        <Grid item xs={2}>
          {props.intl.formatMessage({ id: "Active" })}
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId={"droppable-paymentmethods"} type="PAYMENTMETHOD">
          {(provided) => (
            <List ref={provided.innerRef} {...provided.droppableProps}>
              {paymentMethods?.map((paymentMethodEntry, i) => {
                let paymentMethodName = Object.keys(paymentMethodEntry)[0];
                let paymentMethod = paymentMethodEntry[paymentMethodName];
                return (
                  <AuthorizationWrapper
                    permission={"payment_methods." + paymentMethodName}
                    child={
                      <Draggable
                        type="PAYMENTMETHOD"
                        index={i}
                        key={paymentMethodName}
                        draggableId={"draggable-" + paymentMethodName}
                      >
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef} {...provided.draggableProps}>
                            <Grid
                              style={{ marginTop: 12 }}
                              container
                              spacing={1}
                              key={paymentMethodName}
                              alignItems={"center"}
                            >
                              <Grid item xs={1}>
                                <div
                                  {...provided.dragHandleProps}
                                  style={{
                                    cursor: "move",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  <DragHandleIcon
                                    style={{
                                      marginLeft: 0,
                                      marginRight: 10,
                                    }}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={2}>
                                {/*{props.intl.formatMessage({ id:  })}*/}
                                <Typography>{paymentMethod.name}</Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <EditTextField
                                  value={paymentMethod.description === null ? "" : paymentMethod.description}
                                  onBlur={(value, setBeginValue) => {
                                    value = value === "" ? null : value;
                                    let newPaymentMethods = JSON.parse(JSON.stringify(paymentMethods));
                                    newPaymentMethods[i][paymentMethodName].description = value;
                                    props.onSave(newPaymentMethods).then(() => {
                                      setBeginValue(value);
                                      setPaymentMethods(newPaymentMethods);
                                    });
                                  }}
                                />
                              </Grid>
                              <Grid item xs={2}>
                                <EditPriceTextField
                                  variant={"standard"}
                                  price={paymentMethod.extra_costs}
                                  onBlur={(value, setBeginValue) => {
                                    let newPaymentMethods = JSON.parse(JSON.stringify(paymentMethods));
                                    if (value == null || value === "") {
                                      value = 0;
                                    }
                                    newPaymentMethods[i][paymentMethodName].extra_costs = value;
                                    props.onSave(newPaymentMethods).then(() => {
                                      setBeginValue(value);
                                      setPaymentMethods(newPaymentMethods);
                                    });
                                  }}
                                />
                              </Grid>
                              <Grid item xs={2}>
                                <EditPercentageTextField
                                  variant={"standard"}
                                  percentage={paymentMethod.extra_percentage}
                                  onBlur={(value, setBeginValue, setValue) => {
                                    let newPaymentMethods = JSON.parse(JSON.stringify(paymentMethods));
                                    newPaymentMethods[i][paymentMethodName].extra_percentage = value;
                                    props.onSave(newPaymentMethods).then(() => {
                                      setBeginValue(value.toString());
                                      setValue(value.toString());
                                      setPaymentMethods(newPaymentMethods);
                                    });
                                  }}
                                  InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={2}>
                                <EditSwitch
                                  onChange={(value, setBeginValue) => {
                                    let newPaymentMethods = JSON.parse(JSON.stringify(paymentMethods));
                                    newPaymentMethods[i][paymentMethodName].active = value ? 1 : 0;
                                    props.onSave(newPaymentMethods).then(() => {
                                      setBeginValue(value);
                                      setPaymentMethods(newPaymentMethods);
                                    });
                                  }}
                                  value={paymentMethod.active === 1}
                                  size="small"
                                />
                              </Grid>
                            </Grid>
                          </div>
                        )}
                      </Draggable>
                    }
                  />
                );
              })}
              {provided.placeholder}
            </List>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
}

export default withIntl(PaymentMethodInhouse);
